<template>
    <span
        class="text-danger float-left mr-1"
        v-if="evento.statusId != 2 && meta.statusId != 2">
        <i
            class="fa fa-ban fa-lg icon-button"
            title="Cancelar Meta"
            @click.stop="confirmarCancelar(meta.idMeta)"
        ></i>
    </span>
</template>

<script>

export default {
    props: {
        evento: {
            type: Object,
            default: () => ({})
        },

        meta: {
            type: Object,
            default: () => ({})
        },
        
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarCancelar(id) {
            this.$swal({
                title: 'Cancelar',
                html:
                    'Deseja Cancelar a Meta <strong>' +
                    this.meta.tipoInstrumentoDescricao +
                    '</strong> ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.cancelar(id)
                }
            })
        },

        cancelar(id) {
            this.$store.dispatch('addRequest')
            this.dataServicos.cancelarMeta(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Meta cancelada com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarLista')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    }
}
</script>
